import type { ReactNode } from 'react';

export const symbol_chevron_line_up: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M270-660q-13 0-21.5-8.5T240-690q0-13 8.5-21.5T270-720h420q13 0 21.5 8.5T720-690q0 13-8.5 21.5T690-660H270Zm210 244L313-249q-9 9-21 8.5t-21-9.5q-9-9-9-21.5t9-21.5l188-188q9-9 21-9t21 9l193 193q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9L480-416Z"
		/>
	</svg>
);
